// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"392":"f2d02c4d","515":"b5d6c447","710":"0ad966f3","754":"27716655","894":"276d653e","977":"c5d0983d"}[chunkId] + ".css";
};